import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AttendanceSettings } from '../../_models/academic/attendance/attendance-settings.interface';
import { AttendanceSession } from '../../_models/academic/attendance/attendance-session.interface';
import { AttendanceStatusBackend } from '../../_models/academic/attendance/attendance-status-backend.interface';
import { AttendanceStatusRoles } from 'src/app/_models/academic/attendance/attendance-status-roles.interface';
import {
  AttendanceSearchModel,
  RegisterAttendanceModel,
  AttendaceSectionSearchModel,
  StudentAttendaceSearchModel,
  ViewWiseFilter,
  StudentViewWiseFilter,
  SubmissionAnalyticsFilter,
  AttendanceStatisticsReport,
  FinalStateFilter,
  TodayAttendanceSearch
} from 'src/app/_models';
import * as moment from 'moment';
import { ClassSection } from '../../_models/academic/attendance/ClassSection';

@Injectable({
  providedIn: 'root'
})
// tslint:disable-next-line:class-name
export class attendanceService {
  private url: string;

  constructor(public http: HttpClient) {
    this.url = `${environment.apiUrl}`;
  }

  getAttendanceSettings() {
    return this.http.get(`${this.url}Attendance/GetAttendanceSettings`);
  }

  updateAttendanceSettings(setting: AttendanceSettings) {
    return this.http.put(`${this.url}Attendance/UpdateAttendanceSettings`, setting);
  }

  getAllAttendanceSession() {
    return this.http.get(`${this.url}Attendance/GetAllAttendanceSession`);
  }

  addAttendanceSession(Session: AttendanceSession) {
    return this.http.post(`${this.url}Attendance/AddAttendanceSession`, Session);
  }

  updateAttendanceSession(Session: AttendanceSession) {
    return this.http.put(`${this.url}Attendance/UpdateAttendanceSession`, Session);
  }

  deleteAttendanceSession(SessionId: number) {
    return this.http.delete(`${this.url}Attendance/DeleteAttendanceSession/${SessionId}`);
  }

  getAllAttendanceStatus() {
    return this.http.get(`${this.url}Attendance/GetAllAttendanceStatus`);
  }

  addAttendanceStatus(Status: AttendanceStatusBackend) {
    return this.http.post(`${this.url}Attendance/AddAttendanceStatus`, Status);
  }

  updateAttendanceStatus(Status: AttendanceStatusBackend) {
    return this.http.put(`${this.url}Attendance/UpdateAttendanceStatus`, Status);
  }

  deleteAttendanceStatus(StatusId: number) {
    return this.http.delete(`${this.url}Attendance/DeleteAttendanceStatus/${StatusId}`);
  }

  getAllAttendanceStatusRoles(StatusId: number) {
    return this.http.get(`${this.url}Attendance/GetAllAttendanceStatusRoles/${StatusId}`);
  }

  deleteAttendanceStatusRoles(StatusId: number) {
    return this.http.delete(`${this.url}Attendance/DeleteAttendanceStatusRoles/${StatusId}`);
  }
  createOrUpdateAttendanceStatusRoles(Status: AttendanceStatusRoles[]) {
    return this.http.post(`${this.url}Attendance/CreateOrUpdateAttendanceStatusRoles`, Status);
  }
  getAttendanceSessionsByClassId(classId: number) {
    return this.http.get(`${this.url}Attendance/GetAttendanceSessionByClassId/${classId}`);
  }
  getAttendanceStudents(search: AttendanceSearchModel) {
    return this.http.post(`${this.url}Attendance/GetAttendaceStudents`, search);
  }
  registerAttendance(registerAttendanceModel: RegisterAttendanceModel) {
    return this.http.post(`${this.url}Attendance/RegisterAttendance`, registerAttendanceModel);
  }
  getAttendanceClassesByDate(date: string) {
    return this.http.post(
      `${this.url}Attendance/GetAttendanceClassByDate`,
      new Date(
        moment(date, 'YYYY-MM-DD')
          .locale('en')
          .format('YYYY-MM-DD') + 'T00:00:00.000Z'
      )
    );
  }
  getAttendanceSectionByClassDate(attendaceSectionSearchModel: AttendaceSectionSearchModel) {
    return this.http.post(`${this.url}Attendance/GetAttendanceSectionByClassDate`, attendaceSectionSearchModel);
  }
  getStudantAttendanceForClassSectionDate(atudentAttendaceSearchModel: StudentAttendaceSearchModel) {
    return this.http.post(`${this.url}Attendance/GetStudantAttendanceForClassSectionDate`, atudentAttendaceSearchModel);
  }
  getMonths() {
    return this.http.get(`${this.url}Attendance/GetAttendanceMounth`);
  }
  GetViewWaiseAttendace(data: ViewWiseFilter) {
    return this.http.post(`${this.url}Attendance/GetViewWaiseAttendace`, data);
  }
  GetStudentAttendace(data: StudentViewWiseFilter) {
    return this.http.post(`${this.url}Attendance/GetStudentAttendace`, data);
  }
  GetStudentAttendaceByStudentId(id: string) {
    return this.http.get(`${this.url}Attendance/GetStudentAttendance/${id}`);
  }

  GetSubmissionAnalytics(data: SubmissionAnalyticsFilter) {
    return this.http.post(`${this.url}Attendance/SubmissionAnalytics`, data);
  }

  GetStatistics(data: ClassSection) {
    return this.http.post(`${this.url}Attendance/GetStatistics`, data);
  }

  GetMustStudentStatistics(data: ClassSection, statusId: number) {
    return this.http.get(`${this.url}Attendance/GetMustStudentStatistics/${statusId}/${data.classId}/${data.sectionId}`);
  }
  StudentAverageAttendanceReport(data: AttendanceStatisticsReport) {
    return this.http.post(`${this.url}Attendance/StudentAverageAttendanceReport`, data, { responseType: 'blob' });
  }
  GetClassSectionsAverageAttendanceReport() {
    return this.http.get(`${this.url}Attendance/GetClassSectionsAverageAttendanceReport`, { responseType: 'blob' });
  }
  GetTodayWaiseStatistics(date: string) {
    return this.http.post(
      `${this.url}Attendance/GetTodayWaiseStatistics`,
      new Date(
        moment(date, 'YYYY-MM-DD')
          .locale('en')
          .format('YYYY-MM-DD') + 'T00:00:00.000Z'
      )
    );
  }
  UpdateOrRemoveStudentAttendaceFinalState(finalStateFilter: FinalStateFilter) {
    return this.http.post(`${this.url}Attendance/UpdateOrRemoveStudentAttendaceFinalState`, finalStateFilter);
  }

  GetTodyAttendaceStudents(todayAttendanceObj: TodayAttendanceSearch) {
    return this.http.post(`${this.url}Attendance/GetTodyAttendaceStudents/`, todayAttendanceObj);
  }
}
